'use client';

import 'es6-symbol/implement';
import { SnackbarProvider } from 'notistack';
import * as ReactDOM from 'react-dom';
import * as smoothscroll from 'smoothscroll-polyfill';
import fetchConfig from './config';
import { EslManager } from './EslManager';
import { snackbarActionStack } from './Common/Components/Notifications';
import { CssBaseline } from '@mui/material';
import { EkkoProvider } from './Common/Providers/EkkoProvider';
import { TaskCollectionProvider } from './Common/Providers/TaskCollectionProvider';
import { NavigationProvider } from './Common/Providers/NavigationProvider';
import SearchBarProvider from './Common/Providers/SearchBarProvider';
import { PaginationProvider } from './Common/Providers/PaginationProvider';
import { ThemeModeProvider } from './Common/Providers/ThemeModeProvider';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallbackComponent } from './Welcome/Components/ErrorFallbackComponent';

// TODO: auto-generated in MUIv5 migration. elaborate whether it's needed
/*declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}*/

(async () => {
  smoothscroll.polyfill();
  const config = await fetchConfig();

  ReactDOM.render(
    <ThemeModeProvider>
      <CssBaseline />
      <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
        <SnackbarProvider maxSnack={4} autoHideDuration={10000} action={snackbarActionStack}>
          <EkkoProvider config={config}>
            <PaginationProvider>
              <SearchBarProvider>
                <NavigationProvider>
                  <TaskCollectionProvider>
                    <EslManager />
                  </TaskCollectionProvider>
                </NavigationProvider>
              </SearchBarProvider>
            </PaginationProvider>
          </EkkoProvider>
        </SnackbarProvider>
      </ErrorBoundary>
    </ThemeModeProvider>,
    document.getElementById('root') as HTMLElement,
  );
})();
